import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import ReactUtils from '../../packages/react-utils/react-utils.js';
import { headerChildrenValidator } from './header-children-validator.js';
import styles from './header.scss.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('header', styles);
var Header = function (_a) {
  var children = _a.children,
    extraClasses = _a.extraClasses,
    _b = _a.fullwidth,
    fullwidth = _b === void 0 ? false : _b,
    _c = _a.fixed,
    fixed = _c === void 0 ? false : _c,
    rest = __rest(_a, ["children", "extraClasses", "fullwidth", "fixed"]);
  var getSection = function (sectionName) {
    return ReactUtils.getChildrenByName(children, sectionName)[0];
  };
  return /*#__PURE__*/React__default__default.createElement("header", __assign({
    className: bem.b({
      fullwidth: fullwidth,
      unfixed: !fixed
    }, extraClasses)
  }, rest), /*#__PURE__*/React__default__default.createElement("div", {
    className: bem.e('inner')
  }, getSection('HeaderSkipLinks'), getSection('HeaderBrand'), getSection('HeaderNavigation'), getSection('HeaderBurgerMenu'), getSection('HeaderWidgets')));
};
Header.displayName = 'Header';
Header.propTypes = {
  children: headerChildrenValidator(),
  extraClasses: PropTypes__default.string,
  fullwidth: PropTypes__default.bool,
  fixed: PropTypes__default.bool
};
var header = Injecss(Header, styles);

export { Header, header as default };
